import React, { useEffect, useState, useCallback } from 'react';
import {
  ATMModal,
  ATMMenu,
  ATMButton,
  IORGDataTableQueryState,
} from 'shared-it-appmod-ui';
import { useFireDispatchDetailsContext } from 'src/contexts/fire-dispatch-details.context';
import { useFireDispatchContext } from 'src/contexts/fire-dispatch.context';
import Lang from 'src/libraries/language';
import { actionTypes } from 'src/ducks/fire-dispatch.duck';
import {
  getFireDispatchStatus,
  getTableListParams,
} from 'src/selectors/fire-dispatch.selector';
import ChangeLogs from 'src/components/pages/change-logs/change-logs.component';
import FireDispatchDetailsHeader from './fire-dispatch-header/fire-dispatch-header.component';
import FireDispatchDetails from './fire-dispatch-details/fire-dispatch-details.component';
import styles from './fire-dispatch-details.module.scss';

export interface IProps {
  dispatchId?: number | null;
  open: boolean;
  onClose: () => void;
}

const FireDispatchDetailsModal: React.FC<IProps> = ({
  dispatchId,
  open,
  onClose,
}) => {
  const { state, actions } = useFireDispatchDetailsContext();
  const { state: logState, actions: logActions } = useFireDispatchContext();
  const [tabSelected, setTabSelected] = useState<string | undefined>(
    Lang.LBL_FIRE_DISPATCH_DETAILS
  );

  useEffect(() => {
    if (open && dispatchId) {
      actions.getFireDispatchDetailsData(dispatchId ?? 0);
    }
  }, [dispatchId]);

  const handleFetch = useCallback(
    (params: IORGDataTableQueryState) => {
      const data = getTableListParams(params);

      logActions.changeLogGET(dispatchId ?? 0, data);
    },
    [dispatchId]
  );

  return (
    <ATMModal onClose={onClose} open={open} size="fullscreen">
      <FireDispatchDetailsHeader
        dispatchId={state.fireDispatch?.dispatchId}
        status={state.fireDispatch?.status}
        data={state.data}
      />
      <ATMModal.Content scrolling className={styles.content}>
        <ATMMenu pointing secondary>
          <ATMMenu.Item
            name={Lang.LBL_FIRE_DISPATCH_DETAILS}
            active={tabSelected === Lang.LBL_FIRE_DISPATCH_DETAILS}
            onClick={() => setTabSelected(Lang.LBL_FIRE_DISPATCH_DETAILS)}
          />
          <ATMMenu.Item
            name={Lang.LBL_FIRE_DISPATCH_CHANGE_LOGS}
            active={tabSelected === Lang.LBL_FIRE_DISPATCH_CHANGE_LOGS}
            onClick={() => setTabSelected(Lang.LBL_FIRE_DISPATCH_CHANGE_LOGS)}
          />
        </ATMMenu>
        {tabSelected === Lang.LBL_FIRE_DISPATCH_DETAILS &&
          state.fireDispatch &&
          state.fireDispatch?.dispatchId && (
            <FireDispatchDetails fireDispatch={state.fireDispatch} />
          )}
        {tabSelected === Lang.LBL_FIRE_DISPATCH_CHANGE_LOGS && (
          <ChangeLogs
            data={logState.changeLog}
            total={logState.logTotal}
            loading={
              getFireDispatchStatus(
                logState,
                actionTypes.FIRE_DISPATCH_CHANGE_LOG_FETCH
              ).fetching
            }
            handleFetch={handleFetch}
          />
        )}
      </ATMModal.Content>
      <ATMModal.Actions>
        <ATMButton secondary onClick={onClose}>
          Close
        </ATMButton>
      </ATMModal.Actions>
    </ATMModal>
  );
};

export default FireDispatchDetailsModal;
